import { render, staticRenderFns } from "./proxyDepartmentList.vue?vue&type=template&id=7da1954e&scoped=true"
import script from "./proxyDepartmentList.vue?vue&type=script&lang=js"
export * from "./proxyDepartmentList.vue?vue&type=script&lang=js"
import style0 from "./proxyDepartmentList.vue?vue&type=style&index=0&id=7da1954e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1954e",
  null
  
)

export default component.exports